<div class="flex flex-row">
    <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
  </div>
  <div class="top-panel p-16">
    <div class="flex flex-row justify-between mb-20">
      <div class="flex flex-row items-center">
        <h4 class="mat-subtitle-1 fw-600 mb-0 mr-20">{{'EXTERNAL_INSTANCE.INSTANCES' | transloco}}</h4>
        <app-default-filter [defaultFilterOptions]="defaultFilterOptions"
                            [selectedDefaultFilter]="selectedDefaultFilter" (changed)="defaultFilterChanged($event)"></app-default-filter>
      </div>
      <div class="flex flex-row justify-center items-center">
        <div class="flex justify-between items-center search-wrapper">
          <app-search-filter (keyup)="searchInstance($event)" [placeholder]="'INSTANCE_MGMT.SEARCH_INSTANCE'"></app-search-filter>
        </div>
        <button class="flex justify-center items-center context-menu-icon height menu-btn pl-6 pr-6" (click)="filterColumns()">
          <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
          <span class="fw-500 filters">{{'EXTERNAL_INSTANCE.FILTERS' | transloco}}</span>
        </button>
        <div *ngIf="permissionsMap[Permission.ADD_TENANT]" class="right-tenant fs-16 fw-700 pr-6">
          <button  type="button" class="flex justify-center items-center tenant-gradient layout-row layout-align-end-start mat-body-2 mb-0 fw-700" mat-button (click)="createInstance()">
            <mat-icon svgIcon="add" class="icon-md-2 pr-4"></mat-icon>
            {{'TENANT_FORM.2.0_INSTANCE' | transloco }}
          </button>
        </div>
      </div>
    </div>
    <div class="flex flex-row flex-wrap items-center pt-10 pb-16">
      <div class="flex flex-row items-center mr-16" *ngIf="managementType">
        <span class="fw-400">{{ 'TOOLBAR.TYPE' | transloco }}</span>
        <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
          {{managementType === ManagementTypes.EXTERNAL? ('INSTANCE_LIST.EXTERNAL' | transloco) : ('INSTANCE_LIST.EXTERNAL_FOR_ACTION' | transloco)}}
          <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(managementType)"></mat-icon>
        </span>
      </div>
      <div class="flex flex-row items-center" *ngIf="tenantId">
        <span class="fw-400">{{ 'TOOLBAR.TENANT' | transloco }}</span>
        <ng-container *ngIf="isMultipleTenant else individualTenant">
          <span *ngFor="let tenant of tenantId" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
            {{tenant | uppercase}}
            <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(tenant)"></mat-icon>
          </span>
        </ng-container>
        <ng-template #individualTenant>
          <span *ngIf="tenantId" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
            {{tenantId | uppercase}}
            <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(tenantId)"></mat-icon>
          </span>
        </ng-template>
      </div>
      <div class="flex flex-row items-center" *ngIf="status">
        <span class="fw-400">{{ 'TOOLBAR.STATUS' | transloco }}</span>
        <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
          {{status | titlecase}}
          <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(status)"></mat-icon>
        </span>
      </div>
      <div class="flex flex-row items-center mr-16">
        <span *ngIf="tenantId || status" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg" (click)="resetFilter()">
          {{ 'BUTTONS.CLEAR_ALL' | transloco }}
        </span>
      </div> 
    </div>
    <div class="flex flex-col border-radius">
      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="mat-elevation">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-16 fw-500"> {{'EXTERNAL_INSTANCE.INSTANCE_NAME' | transloco }}</th>
          <td mat-cell *matCellDef="let data" class="cursor-pointer" (click)="openInstanceDetails(data)">
            <div class="flex justify-start items-center">
              <span class="cell-data instance-name" [title]="data.name">{{data.name}}</span>
              <mat-icon *ngIf="data.name === 'Demo Instance'" svgIcon="info" class="icon-md-1 pl-8 icon"
                matTooltipPosition="above" matTooltipClass="tooltip-inner above pl-8 pr-8 pt-4 pb-4 fs-12" matTooltip="Sandbox"></mat-icon>
            </div>
          </td>
        </ng-container>
  
        <ng-container matColumnDef="tenantId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-16 fw-500"> {{'EXTERNAL_INSTANCE.TENANT' | transloco | uppercase }} </th>
          <td mat-cell *matCellDef="let data" class="cell-data" [title]="data.id"> {{data.tenantId}} </td>
        </ng-container>
  
        <ng-container matColumnDef="regionPair">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-16 fw-500"> {{'EXTERNAL_INSTANCE.REGION' | transloco }} </th>
          <td mat-cell *matCellDef="let data"> {{data.region || data.regionPair}} </td>
        </ng-container>
  
        <ng-container matColumnDef="dataZone">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-16 fw-500"> {{'EXTERNAL_INSTANCE.DATA_ZONE' | transloco }} </th>
          <td mat-cell *matCellDef="let data"> {{data.dataZone}} </td>
        </ng-container>
  
        <ng-container matColumnDef="deploymentClass">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-16 fw-500"> {{'EXTERNAL_INSTANCE.INSTANCE_CLASS' | transloco }} </th>
          <td mat-cell *matCellDef="let data"> {{data.deploymentClass}} </td>
        </ng-container>
  
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-16 fw-500"> {{'EXTERNAL_INSTANCE.STATUS' | transloco }} </th>
          <td mat-cell *matCellDef="let data">
            <span class="status p-4" [ngClass]="data?.status">{{data.status | titlecase}}</span>
          </td>
        </ng-container>
  
        <!-- <ng-container matColumnDef="endpoints">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="flex justify-center fs-16 fw-500"> {{'EXTERNAL_INSTANCE.ENDPOINTS' | transloco }} </th>
          <td mat-cell *matCellDef="let data" class="pl-36">
            <div class="flex justify-center items-center endpoint-button">
              <mat-icon svgIcon="desktop_windows" class="icon-sm"></mat-icon>
            </div>
          </td>
        </ng-container> -->
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-card *ngIf="showSpinner" class="flex spinner-container spinner">
        <mat-spinner diameter="24"
          color="primary"
          mode="indeterminate">
        </mat-spinner>
      </mat-card>
      <div *ngIf="instanceData?.data?.length === 0 && !showSpinner && !isFailed" class="flex items-center justify-center pt-48 pb-48">
        {{'EXTERNAL_INSTANCE.NO_INSTANCE_MESSAGE' | transloco }}
      </div>
      <div *ngIf="isFailed || this.dataSource?.length === 0" class="flex items-center justify-center pt-48 pb-48">
        {{'EXTERNAL_INSTANCE.NO_DATA_FOUND' | transloco }}
      </div>
      <app-paginator *ngIf="showPagination && !showSpinner && !isFailed" class="p-24" [length]="instanceData?.data?.length" [pageSizeOptions]="[10, 15, 20]"
        [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChanged($event)"></app-paginator>
    </div>
  </div>
  